<!--
~ Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
~
~ The information and source code contained herein is the exclusive property of
~ Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
~ or in part without the explicit written authorization from Anvilor Solutions LLC.
-->

<div
  class="app-wrap"
  [style.background]="app.theming.appBackground$ | async"
  [style.color]="app.theming.appForeground$ | async"
>
  @if (app.store.isDebugMode$ | async) {
    <app-debug-mode-tools></app-debug-mode-tools>
  }
  @if (app.store.isNonLiveEnv$ | async) {
    <app-attention-banner label="SANDBOX"></app-attention-banner>
  }
  @if (app.loading.isLoadingForm$ | async) {
    <mat-spinner [diameter]="170"></mat-spinner>
  }
  <div class="rui-container" [class.v1-layout]="isV1Config$ | async">
    @if (app.loading.isFullyLoaded$ | async) {
      @if (showV1PostSubmit$ | async) {
        <div class="v1-post-submit">
          <mat-card appearance="raised">
            <p>Your response has been recorded!</p>
          </mat-card>
        </div>
      } @else {
        <nvl-rui-instance></nvl-rui-instance>
      }
    }
  </div>
  <app-survey-footer-control></app-survey-footer-control>
</div>
